module.exports = __webpack_public_path__ + "img/icon-MA-Spotlight.575f3ef1.png";